import { SearchBox, Toggle } from '@fluentui/react';
import React, { useContext , useState} from 'react';
import DownloadDialog from './DownloadDialog';
import { MyContext } from '../../../../../context';
import MailDownloadDialog from './MailDownloadDialog';
import './Transscript.scss';



export default function MailTranscript({ mailInfo, metaData, client, auth }) {
const context = useContext(MyContext);
const [showHtml, setShowHtml] = useState(false);
const [search, setSearch] = useState(null);

     return (
          <div>
               <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                    <MailDownloadDialog  
                    client={client}
                    authorization={auth}
                    conversationId={metaData.conversationId}
                     />
                    <SearchBox
                         disabled={showHtml}
                         styles={{ root: { width: 200 } }}
                         placeholder={context.getTranslation("detailContainer", "search")}
                         onChange={(ev,v) => setSearch(v)}
                    />
                    <span style={{flexGrow: 1}}>
                         {/*Spacer*/}
                         </span>
                    <Toggle inlineLabel label={context.getTranslation("detailContainer","mailDisplaySwitch")} onChange={(ev,v) => setShowHtml(v)} />
               </div>
               <h4 style={{ flexGrow: 1 }}>{metaData.topic}</h4>
               {renderMailBody(mailInfo.mailBody, showHtml, search)}
               <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', gap: '10px' }}>
                    <h5>Attachments</h5>
                    {mailInfo.attachments.map(v => (<span key={'attachment_' + v} style={{ border: '1px solid black', padding: '2px' }}>{v}</span>))}
               </div>
          </div>
     )
}

function renderMailBody(body, showHtml, search) {
     if (showHtml) {
          return renderMailBodyAsHtml(body)
     } else {
          return renderMailBodyAsText(body,search)
     }
}

function renderMailBodyAsHtml(body) {
     return <div className="mail-body-html" dangerouslySetInnerHTML={{ __html: body }}></div>
}

function renderMailBodyAsText(body,search) {
     const textFragments = extractRawTextFromHtmlString(body);
     let res = [];
     for (const frag of textFragments) {
          if(!searchIsActive(search) || frag.toLowerCase().includes(search.toLowerCase())){
          res.push(<span>{frag}</span>)
          res.push(<br />)
          }
     }
     return res;
}

function searchIsActive(search){
     return search
}

function extractRawTextFromHtmlString(html) {
     const doc = new DOMParser().parseFromString(html, 'text/html');
     const walker = document.createTreeWalker(
          doc.body,
          NodeFilter.SHOW_TEXT,
          null,
          false
     );
     const texts = [];
     let node = walker.nextNode();
     while (node) {
          texts.push(node.nodeValue);
          node = walker.nextNode();
     }
     return texts;
}